var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment-list-page"},[_vm._l((_vm.commentsData),function(item){return _c('div',{key:item.order_id,staticClass:"comment-list-item"},[_c('commentItem',{attrs:{"item":item}})],1)}),(!_vm.commentsData.length)?_c('Empty',{attrs:{"description":"暂无评论"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }